import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';

import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking/remix-thinking-plugin';

/**
 * Ends the thinking presentation for a flow that is over but still owns its machine session.
 *
 * The Rovo chat handoff needs this: it emits no machine event and keeps ownership until the sidebar
 * is acknowledged, so the `setThinkingComplete(true)` that ends the bar in control is a `legacy-*`
 * write the reducer drops.
 *
 * Internal command: not on the plugin command API, not exported from the package.
 */
export const dismissRemixThinkingLifecycle: EditorCommand = ({ tr }) => {
	tr.setMeta(remixThinkingPluginKey, {
		lifecycle: { kind: 'dismiss' },
	} satisfies RemixThinkingPluginMeta);
	return tr;
};
